

















































































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGrade, TbMember, TbReport } from '@/http';
import { calendarPanel,NumberKeyboard } from "@/components";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
import Bus from '@/common/util/bus';
dayjs.locale('zh-cn')
import { fmoney } from '@/common/money';
@Component({ 
    components: {
        calendarPanel,NumberKeyboard
    },
})
export default class balanceDetail extends Vue {
    public $refs: {
    };

    @Prop({
        type:Object,
        default:()=>{

        }
    })
    form:any;

    gradeList = [];

    /**查询项 */
    searchValue={
        orderNo:"",
        type:null,
        start:"",
        end:"",
        skip:0,
        count:10,
    }
    /**时间类型下拉 */
    showStatusPopover = false;
    typeOptions=[
        {
            label:"全部变动类型",
            value:null,
        },
        {
            label:"会员充值",
            value:1,
        },
        {
            label:"消费支付",
            value:2,
        },
        {
            label:"退货退回",
            value:3,
        },
        {
            label:"余额调整-增加",
            value:4,
        },
        {
            label:"余额调整-减少",
            value:5,
        },
        
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    timeActive=null;

    /**新增会员弹窗 */
    addVipShow = false;
    isAdd = true;

    totalInfo:any={};

    fmoney = fmoney;

   get getTypeStatus(){
    let str = "";
    str = this.typeOptions.find(v=>v.value==this.searchValue.type).label
    return str;
   }

    created() {
        
    }

    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padShopInfo'));
        Bus.$on('refreshVipDetail',()=>{
            this.onRefresh();
        })
       
    }

    getPayName(val){
        let str = "";
        switch (val) {
            case 1:
                str="会员充值"
                break;
            case 2:
                str="消费支付"
                break;
            case 3:
                str="退货退回"
                break;
            case 4:
                str="余额调整-增加"
                break;
            case 5:
                str="余额调整-减少"
                break;
        
            default:
                break;
        }
        return str;
    }

   
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
    
        this.pickerShow = false;
        this.timeActive = null;
        this.setTimeSearch();
    }
    closeTime(){
        this.pickerShow = false;
    }
    
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbMember.GetBalanceList(Object.assign({},this.searchValue,{
                memberId:this.form.id,
                shopNo:this.userInfo.shopNo
            }))
            this.list = this.searchValue.skip==0? res.item2.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    createTimeAll:dayjs(v.createTime).format('YYYY-MM-DD HH:mm:ss'),
                }
            }):this.list.concat(res.item2.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    createTimeAll:dayjs(v.createTime).format('YYYY-MM-DD HH:mm:ss'),
                }
            }));
            this.total  = res.item1;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            await this.getTotal();
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
    async getTotal(){
        let res = await TbMember.GetBalanceTotal(Object.assign({},this.searchValue,{
            memberId:this.form.id,
            shopNo:this.userInfo.shopNo
        }))
        this.totalInfo = {
            num1:res.item1,
            num2:res.item2,
        };
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=10;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbMember.GetBalanceList(Object.assign({},this.searchValue,{
                memberId:this.form.id,
                shopNo:this.userInfo.shopNo
            }))
            this.list = res.item2.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    createTimeAll:dayjs(v.createTime).format('YYYY-MM-DD HH:mm:ss'),
                }
            });
            this.total  = res.item1;
            await this.getTotal();
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            orderNo:"",
            type:null,
            start:"",
            end:"",
            skip:0,
            count:10,
        }
        this.timeActive=null;
        this.startDate = "";
        this.endDate = "";
        this.showStatusPopover = false;
        this.onRefresh();
    }
   
    sortFun(val){}
    changeTypeStatusXL(item,index){
        this.showStatusPopover = false;
        this.searchValue.type = item.value;
        this.onRefresh();
    }
    async chooseTime(type){
        this.timeActive = type;
        // 获取当前日期
        const today = dayjs();
        const firstDayOfWeek = dayjs().startOf('week');
        const firstDayOfMonth = dayjs().startOf('month');
        const prevMonthStart = today.subtract(1, 'month').startOf('month');  
        const prevMonthEnd = today.subtract(1, 'month').endOf('month')
        switch (type) {
            case 1:
                this.startDate = today.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 2:
                this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 3:
                this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 4:
                this.startDate = prevMonthStart.format("YYYY-MM-DD");
                this.endDate = prevMonthEnd.format("YYYY-MM-DD");
                break;
        
            default:
                break;
        }
        await this.setTimeSearch();
    }
    async setTimeSearch(){
        this.searchValue.start = this.startDate+" 00:00:00";
        this.searchValue.end = this.endDate+" 23:59:59";
        await this.onRefresh();
    }

    
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/balanceDetail.vue